<template>
    <div class="container-fluid h-100">
        <div class="d-flex justify-content-center align-items-center h-100">
            <div class="col-12 col-md-8">
                <div class="box">
                    <h2>{{ $t('compte.reinitialiser_mdp') }}</h2>
                    <form @submit.prevent="send">
                        
                        <!-- Password -->
                        <div class="form-group">
                            <label for="name">{{ $t('compte.password') }}<sup>*</sup></label>
                            
                            <div class="input-group">
                                <input :type="showPassword ? 'text' : 'password'" class="form-control" name="password" :placeholder="$t('compte.password')" v-model="form.password" :disabled="isWorking" autocomplete="off" required>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" @click="showPassword = !showPassword">
                                        <font-awesome-icon :icon="showPassword ? ['fal', 'eye-slash'] : ['fal', 'eye']" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Confirm Password -->
                        <div class="form-group">
                            <label for="name">{{ $t('compte.password_confirmation') }}<sup>*</sup></label>
                            
                            <div class="input-group">
                                <input :type="showPassword ? 'text' : 'password'" class="form-control" name="confirmPassword" :placeholder="$t('compte.password_confirmation')" v-model="form.confirmPassword" :disabled="isWorking" autocomplete="off" required>
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" @click="showPassword = !showPassword">
                                        <font-awesome-icon :icon="showPassword ? ['fal', 'eye-slash'] : ['fal', 'eye']" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            {{ $t('compte.mdp_doit_contenir') }} :
                            <ul>
                                <li :class="password_lettre">{{ $t('compte.mdp_au_moins_une_lettre') }}</li>
                                <li :class="password_chiffre">{{ $t('compte.mdp_au_moins_un_chiffre') }}</li>
                                <li :class="password_symbole">{{ $t('compte.mdp_au_moins_symbole') }}</li>
                                <li :class="password_caracteres">{{ $t('compte.mdp_plus_12_caractere') }}</li>
                                <li :class="password_identiques">{{ $t('compte.mdp_identiques') }}</li>
                                
                            </ul>
                        </div>
                        
                        <b-alert v-if="errorInfos" variant="danger" show>
                            {{ errorInfos }}
                        </b-alert>
                        
                        <!-- Bouton de validation du formulaire -->
                        <button type="submit" :disabled="!canSubmit" class="mt-4 btn btn-primary btn-block rounded-pill">
                            {{ $t('global.reinitialiser') }}
                            <font-awesome-icon v-if="isWorking" class="mr-1" :icon="['fas', 'spinner']" spin />
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import User from '@/mixins/User'
import Navigation from '@/mixins/Navigation'

export default {
    name: 'PasswordUpdate',
    mixins: [User, Navigation],
    data: () => ({
        errorInfos: null,
        isWorking: false,
        password: null,
        password_confirmation: null,
        form: {
            password: null,
            confirmPassword: null
        },
        canSubmit: false,
        showPassword: false,
        password_lettre: 'password_red',
        password_chiffre: 'password_red',
        password_symbole: 'password_red',
        password_caracteres: 'password_red',
        password_identiques: 'password_red'
    }),
    methods: {
        async send() {
            this.errorInfos = null
            this.isWorking = true
            
            if (this.form.password !== this.form.confirmPassword) {
                this.errorInfos = this.getTrad('error.IPWC')
                this.isWorking = false
                return
            }
            
            try {
                await this.updatePassword(this.$route.params.email, this.$route.params.token, this.form.password)
                const domain = this.$route.query.domain
                if(domain && domain !== window.location.origin) {
                    window.location.replace(domain)
                }
                else {
                    await this.loginUser(this.$route.params.email, this.form.password)
                }
            } catch (err) {
                this.errorInfos = err.message
            } finally {
                this.isWorking = false
            }
        },
        
        checkPassword(password) {
            this.canSubmit = true
            if (password.match(/[a-zA-Z]/)){
                this.password_lettre = 'password_green'
            } else {
                this.password_lettre = 'password_red'
                this.canSubmit = false
            }
            
            if (password.match(/\d/)){
                this.password_chiffre = 'password_green'
            } else{
                this.password_chiffre = 'password_red'
                this.canSubmit = false
            }
            
            if (password.match(/[!"#$%&'()*+,-.:;<=>?@[\]^_`{|}~]/)){
                this.password_symbole = 'password_green'
            } else{
                this.password_symbole = 'password_red'
                this.canSubmit = false
            }
            
            if (password.length >= 12){
                this.password_caracteres = 'password_green'
            } else{
                this.password_caracteres = 'password_red'
                this.canSubmit = false
            }
            
            if (password === this.form.confirmPassword){
                this.password_identiques = 'password_green'
            } else{
                this.password_identiques = 'password_red'
                this.canSubmit = false
            }
        }
    },
    watch: {
        'form.password' (val) {
			this.checkPassword(val || '')
		},
		'form.confirmPassword' () {
			this.checkPassword(this.form.password || '')
		}
    }
}
</script>